module.exports = __webpack_public_path__ + "img/honors_2024.d598997e.png";